function debounce (callbackFunction, ms = 0) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callbackFunction.apply(this, args), ms);
  };
};

function resetArray (arr) {
  arr.length = 0;
}

function getLocalstorageItem(localStorageKeyName) {
  return JSON.parse(window.localStorage.getItem(localStorageKeyName));
}

function setLocalstorageItem(localStorageKeyName, value) {
  window.localStorage.setItem(localStorageKeyName, JSON.stringify(value));
}

function loadYTVideoPlayerScript() {
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/player_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function isYTReady(callbackFunction) {
  function checkYTState() {
    if (window.YT.loaded) {
      clearInterval(listener);
      callbackFunction();
    }
  }
  const listener = setInterval(checkYTState, 300);
}

function isLayoutDoubleColumn() {
  return window.matchMedia("(min-width: 768px)").matches;
}

function initYTState() {
  const videosInitializationConfigs = [{
    id: 'rRD-nVJLAKA',
    playerId: 'ytplayer_0',
    visualized: false,
  },
  {
    id: '5G3RWg2d8jY',
    playerId: 'ytplayer_1',
    visualized: false,
  },
  {
    id: null,
    playerId: 'ytplayer_2',
    visualized: false,
  },
  {
    id: null,
    playerId: 'ytplayer_3',
    visualized: false,
  }];

  return window.GLOBAL_PROMOTER_VIDEOS = {
    bullets: null,
    buttons: null,
    instances: [],
    modal: null,
    videoContainers: null,
    videosInitializationConfigs,
    watchlist: getLocalstorageItem('promoterVideosWatchlist') || videosInitializationConfigs,
  };
}

function initYTInstances() {
  isYTReady(function() {
    let player;
    const { instances, videosInitializationConfigs } = window.GLOBAL_PROMOTER_VIDEOS;
    resetArray(instances);

    videosInitializationConfigs.forEach(function(item, index) {
      player = new window.YT.Player(item.playerId, {
        videoId: item.id,
        events: {
          'onStateChange': function(event) {
            if (event.data === window.YT.PlayerState.ENDED) {
              window.GLOBAL_PROMOTER_VIDEOS.bullets[index].classList.add('visualized');

              const updatedWatchlist = window.GLOBAL_PROMOTER_VIDEOS.watchlist.map((el) => {
                if (el.id === item.id) el.visualized = true;
                return el;
              });

              setLocalstorageItem('promoterVideosWatchlist', updatedWatchlist);
            }
          }
        }
      });
      instances.push(player);
    });
  });
}

function initColumnVideoView() {
  return window.GLOBAL_PROMOTER_COLUMN_VIDEO = {
    el: document.querySelector('[data-column-video]'),
    isVisible: isLayoutDoubleColumn(),
    nodelistArr: createColumnVideoNodeList(),
  }
}

function createColumnVideoNodeList() {
  function createColumnVideoItem(item, index) {
    const isFirstVideo = (index === 0) ? 'data-active-video' : '';

    return `
      <div class="promoter-journey-container" ${isFirstVideo}>
        <div class="promoter-journey-item">
          <div class="embed-responsive embed-responsive-16by9 mb-3">
            <div id="ytplayer_${index}"></div>
          </div>
          <h3 class="promoter-journey-main-title mb-3">Aula ${index+1}</h3>
          <h4 class="promoter-journey-item-title">${item.title}</h4>
          <p class="promoter-journey-item-description">${item.description}</p>
        </div>
      </div>
    `
  }

  const columnVideoList = [{
    title: 'Melhores Ferramentas',
    description: 'Vamos falar sobre quais são as principais ferramentas utilizadas pelos divulgadores de sucesso para incrementar suas vendas no Influenciador Magalu',
  },
  {
    title: 'Desvendando o WhatsApp e Telegram',
    description: 'Aprenda como você pode utilizar as duas maiores plataformas de mensagens para incrementar as suas vendas e alcançar ainda mais clientes para sua loja.',
  },
  {
    title: 'Divulgando ofertas nas redes sociais',
    description: 'Descubra como você pode utilizar o Facebook e o Instagram para vender e aprenda dicas práticas para utilizar as duas redes sociais mais usadas para vendas no Brasil e no mundo.',
  },
  {
    title: 'Dicas de ouro',
    description: 'Saiba como utilizar os conteúdos disponibilizados pra você e como começar sua loja do zero. Veja quais são as dicas de ouro para você realizar sua primeira venda e tornar-se um Influenciador Magalu de Sucesso!',
  }];

  const columnVideoNodeList = [];
  columnVideoList.forEach(function (video, index) {
    columnVideoNodeList.push(createColumnVideoItem(video, index));
  });

  return columnVideoNodeList;
}

function mountColumnVideo() {
  window.GLOBAL_PROMOTER_COLUMN_VIDEO.isVisible = true;
  const { el, nodelistArr } = window.GLOBAL_PROMOTER_COLUMN_VIDEO;
  el.innerHTML = nodelistArr.join('');
  initYTInstances();
  updateColumnListView();
  setButtonsEventListeners();
}

function unmountColumnVideo() {
  window.GLOBAL_PROMOTER_COLUMN_VIDEO.isVisible = false;
  const { el } = window.GLOBAL_PROMOTER_COLUMN_VIDEO;
  el.innerHTML = '';
}

function getOrUpdateColumnsNodesReferences() {
  Object.assign(window.GLOBAL_PROMOTER_VIDEOS, {
    bullets: [].slice.call(document.querySelectorAll('.timeline-bullet')),
    buttons: document.querySelectorAll('.promoter-journey-button'),
    videoContainers: [].slice.call(document.querySelectorAll('.promoter-journey-container')),
  });
}

function mountModal() {
  const modalNode = document.createElement('div');
  const modalStructure = `
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body"></div>
      </div>
    </div>
  `;

  modalNode.tabIndex = '-1';
  modalNode.role = 'dialog';
  modalNode.classList.add('modal', 'promoter-journey-modal');
  modalNode.innerHTML = modalStructure;
  document.body.prepend(modalNode);

  const modalNodeBody = modalNode.querySelector('.modal-body');
  const modalCloseButton = modalNode.querySelector('[data-dismiss="modal"]');

  function show() {
    modalNode.classList.add('d-block');
  }
  function hide() {
    modalNode.classList.remove('d-block');
  }

  modalNode.addEventListener('click', function (event) {
    if (event.target.classList.contains('promoter-journey-modal')) hide();
    modalNodeBody.innerHTML = '';
  });
  modalCloseButton.addEventListener('click', function () {
    hide();
    modalNodeBody.innerHTML = '';
  });

  Object.assign(window.GLOBAL_PROMOTER_VIDEOS, {
    modal: {
      el: modalNode,
      body: modalNodeBody,
      show,
      hide,
    }
  });
}

function setButtonsEventListeners() {
  getOrUpdateColumnsNodesReferences();

  let currentVideoIndex = 0;
  const { instances, buttons, videoContainers, videosInitializationConfigs } = window.GLOBAL_PROMOTER_VIDEOS;

  buttons.forEach(function (button, index) {
    const listener = function(event) {
      event.preventDefault();

      if (isLayoutDoubleColumn()) {
        instances.forEach(function(video) {
          video.pauseVideo();
        });

        videoContainers.forEach(function(video) {
          video.removeAttribute('data-active-video')
        });

        currentVideoIndex = index;

        const currentVideo = videoContainers[currentVideoIndex];
        currentVideo.setAttribute('data-active-video', '')
      } else {
        const { modal, videosInitializationConfigs } = window.GLOBAL_PROMOTER_VIDEOS;
        modal.body.innerHTML = `
          <div class="embed-responsive embed-responsive-16by9 mb-3">
            <div id="${videosInitializationConfigs[index].playerId}"></div>
          </div>
        `;

        initYTInstances();
        modal.show();
      }
    }
    const videoHasSourceId = videosInitializationConfigs[index].id;

    (videoHasSourceId)
      ? button.addEventListener('click', listener)
      : button.setAttribute('disabled', '');
  });
}

function updateColumnListView() {

  getOrUpdateColumnsNodesReferences();

  const { bullets, watchlist } = window.GLOBAL_PROMOTER_VIDEOS;

  bullets.forEach(function(item, index) {
    if (watchlist[index] !== undefined) {
      const isVisualized = watchlist[index].visualized;
      if (isVisualized) item.classList.add('visualized');
    }
    return false;
  });
}

function init() {

  // if (!document.querySelector('#venda-mais')) return false

  loadYTVideoPlayerScript();

  initYTState();

  initColumnVideoView();

  createColumnVideoNodeList();

  mountColumnVideo();

  window.addEventListener('resize', debounce(function() {
    if (isLayoutDoubleColumn()) {
      !window.GLOBAL_PROMOTER_COLUMN_VIDEO.isVisible && mountColumnVideo();
    } else {
      window.GLOBAL_PROMOTER_COLUMN_VIDEO.isVisible && unmountColumnVideo();
    }
  }), 250);

  mountModal();

};

export default init();
